import type { FeatureCollection } from 'geojson';
import { AddressSearchResult, PanelParameters, InstallationResult, SurfaceCollection, ExistingPvResult } from '../types/types';

const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_BASE_URL || 'https://pvproapi.enersyte.de';
console.log('backend url', API_BASE_URL)
//'http://localhost:8008'; // This will be proxied to http://localhost:5000

export const searchAddress = async (query: string): Promise<AddressSearchResult> => {
  const response = await fetch(`${API_BASE_URL}/search/?q=${encodeURIComponent(query)}`);
  console.log(response)
  if (!response.ok) throw new Error('Address search failed');
  return response.json();
};

export const getParcel = async (lon: number, lat: number): Promise<AddressSearchResult> => {
  const response = await fetch(`${API_BASE_URL}/parcel/?lon=${encodeURIComponent(lon)}&lat=${encodeURIComponent(lat)}`);
  console.log(response)
  if (!response.ok) throw new Error('parcel search failed');
  return response.json();
};

export const getPanelPlacement = async (
  buildingId: string,
  parameters: PanelParameters,
  filters?: {
    selected_surfaces?: string[];
    selected_obstructions?: string[];
  }
): Promise<InstallationResult> => {
  let url = `${API_BASE_URL}/panelplacement/${buildingId}?panel_width=${parameters.width}&panel_height=${parameters.height}&panel_efficiency=${parameters.efficiency}&panel_min_tilt=${parameters.min_tilt}`;
  if (filters?.selected_surfaces?.length) {
    filters.selected_surfaces.forEach(surface => {
      url += `&surfaces_filter=${surface}`;
    });
  }
  if (filters?.selected_obstructions?.length) {
    filters.selected_obstructions.forEach(obstruction => {
      url += `&obstructions_filter=${obstruction}`;
    });
  }
  console.log(url)
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error('Panel placement calculation failed');
    return response.json();
  }
  catch (error) {
    console.error('Error in promise panel placement:', error);
    throw new Error('Panel placement calculation failed');
  }
};

export const getOrthophoto = async (buildingId: string): Promise<string> => {
  return `${API_BASE_URL}/crop/${buildingId}`
  // const response = await fetch(`${API_BASE_URL}/crop/${buildingId}`);
  // if (!response.ok) throw new Error('Failed to fetch orthophoto');
  // return response.url;
};

export const getSurfaces = async (buildingId: string): Promise<SurfaceCollection> => {
  const response = await fetch(`${API_BASE_URL}/surfaces/${buildingId}`);
  if (!response.ok) throw new Error('Failed to fetch surfaces');
  return response.json();
};

export const getObstructions = async (buildingId: string): Promise<FeatureCollection> => {
  const response = await fetch(`${API_BASE_URL}/obstructions/${buildingId}`);
  if (!response.ok) throw new Error('Failed to fetch obstructions');
  return response.json();
};

export const getExistingPv = async (buildingId: string): Promise<ExistingPvResult> => {
  const response = await fetch(`${API_BASE_URL}/existingpv/${buildingId}`);
  if (!response.ok) throw new Error('Failed to fetch existing PV');
  return response.json();
};